import type { Route } from "@route-types/Keywords/+types/Keywords";
import PageArticleList from "@src/app/components/ArticleList/PageArticleList";
import {
  parsePayload,
  useRouteResponse,
} from "@src/app/hooks/useRouteResponse";
import type { KeywordsPageResponse } from "@src/app/types/response";
import { createMetaTags } from "@src/app/utils/createMetaTags";

import { fetchKeywordPageData } from "./Keywords.server";

export const loader = fetchKeywordPageData;

export const meta = (args: Route.MetaArgs) => {
  const payload = parsePayload<KeywordsPageResponse>(args.loaderData);
  const tagName = payload.tagName || "";

  return createMetaTags({
    title: `${tagName} | Big Reads, Opinions & Columns on China | ThinkChina`,
    description: `${tagName} - Get latest insights on ${tagName} through the eyes of global thought leaders & journalists.`,
    canonical: `https://www.thinkchina.sg/tags/${args.params.tag || ""}`,
    ogInfo: {
      ogTitle: `${tagName} | Big Reads, Opinions & Columns on China`,
    },
  });
};

export default function KeywordsPage() {
  const route = useRouteResponse("keywordPage");

  const tagName = route.tagName || "";
  const tagId = route.tagId || "";

  console.log("KeywordsPage", tagName, tagId);
  return (
    <PageArticleList
      initialData={route.articles || []}
      title={tagName}
      requestPath={`/tags/${tagId}`}
    />
  );
}
